import { useState } from "react";
import { toast } from "sonner";
import { PLATFORMS, SOCIALS } from "@/data/site";
import { api, errMsg } from "@/lib/api";
import { inputCls, btnCls } from "./LoginCard";

const FIELDS = [...PLATFORMS, ...SOCIALS];

export const LinksPanel = ({ links = {}, onSaved }) => {
  const [form, setForm] = useState(() => Object.fromEntries(FIELDS.map((f) => [f.key, links?.[f.key] ?? (f.key === "youtube" ? f.url : "")])));
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/links", form);
      toast.success("Links saved. They're live on the site.");
      onSaved();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} data-testid="admin-links-form" className="space-y-4">
      <p className="text-zinc-300">Paste your profile links. Empty platforms show "Coming soon" on the site.</p>
      {FIELDS.map((f) => (
        <label key={f.key} className="block">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{f.name}</span>
          <input data-testid={`admin-link-${f.key}`} className={`${inputCls} mt-2`} placeholder="https://…" value={form[f.key]} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} />
        </label>
      ))}
      <button data-testid="admin-links-save" disabled={busy} className={btnCls}>Save links</button>
    </form>
  );
};
